import { Box } from "@mui/material";

import EllipsisTooltipCell from "utils/ellipsisTooltipCell";
import ConnectBar from "components/ConnectivityBar";

import {
  buildConnectivityInfo,
  calculateTotalOfflineDuration,
} from "./helper/index";

const deviceColumns = (columnHelper, fromTime, toTime) => [
  columnHelper.accessor("deviceType", {
    header: "Device Type",

    enableSorting: true,

    cell: (info) => {
      const value = info.getValue();

      return <Box>{value ?? "-"}</Box>;
    },
  }),

  columnHelper.accessor("deviceName", {
    header: "Device Name",

    enableSorting: true,

    cell: (info) => {
      const value = info.getValue();

      return <EllipsisTooltipCell text={value ?? "-"} />;
    },
  }),

  columnHelper.accessor("ipAddress", {
    header: "IP Address",

    enableSorting: true,

    sortingFn: (rowA, rowB, columnId) => {
      const ipA = rowA.getValue(columnId);

      const ipB = rowB.getValue(columnId);

      const ipToNumber = (ip) => {
        if (!ip || ip === "-") {
          return 0;
        }

        return ip
          .split(".")
          .reduce((result, part) => result * 256 + Number(part), 0);
      };

      return ipToNumber(ipA) - ipToNumber(ipB);
    },

    cell: (info) => {
      const value = info.getValue();

      return <Box>{value ?? "-"}</Box>;
    },
  }),

  columnHelper.accessor("macAddress", {
    header: "MAC Address",

    enableSorting: true,

    cell: (info) => {
      const value = info.getValue();

      return <Box>{value ?? "-"}</Box>;
    },
  }),

  columnHelper.accessor("segments", {
    id: "connectivity",

    header: "Connectivity of the Week",

    enableSorting: true,

    cell: (info) => {
      const segments = info.getValue() ?? [];

      if (
        !Number.isFinite(fromTime) ||
        !Number.isFinite(toTime) ||
        toTime <= fromTime
      ) {
        return <Box>-</Box>;
      }

      const connectData = buildConnectivityInfo(segments, fromTime, toTime);

      if (connectData.length === 0) {
        return <Box>-</Box>;
      }

      return (
        <Box
          sx={{
            width: "100%",
            minWidth: "250px",

            height: "32px",

            display: "flex",

            alignItems: "center",

            pr: 2,

            boxSizing: "border-box",
          }}
        >
          <ConnectBar
            info={connectData}
            startTime={fromTime}
            endTime={toTime}
          />
        </Box>
      );
    },

    sortingFn: (rowA, rowB, columnId) => {
      const segA = rowA.getValue(columnId) ?? [];

      const segB = rowB.getValue(columnId) ?? [];

      const durA = calculateTotalOfflineDuration(segA, fromTime, toTime);

      const durB = calculateTotalOfflineDuration(segB, fromTime, toTime);
      return durA - durB;
    },
  }),
];

export default deviceColumns;
